import * as React from 'react';
import { IconButton } from '@dropbox/dig-components/buttons';
import { UIIcon } from '@dropbox/dig-icons';
import { FileViewerBreakpoint } from 'js/file_viewer/hooks/responsive_size';
export const ToolbarIcon = ({ label, onClick, icon, disabled, variant, }) => {
    return (React.createElement(IconButton, { variant: variant !== null && variant !== void 0 ? variant : 'transparent', "aria-label": label, onClick: onClick, disabled: disabled },
        React.createElement(UIIcon, { src: icon, width: "20px", height: "20px" })));
};
ToolbarIcon.displayName = "ToolbarIcon"
// useIconsOnlyForToolbar helps us control whether we display icons only on the toolbar when the window is small
// this applies to both preview and edit mode for Video and Image
export const isToolbarIconsOnly = (breakpoint) => {
    return breakpoint === FileViewerBreakpoint.MD || breakpoint === FileViewerBreakpoint.SM;
};
//# sourceMappingURL=utils.preenvesnextjs.map
